export default "__VITE_ASSET__DwWjCtdy__"